/**
 * Recently Viewed Products
 * Reads current-product data from the JSON data island rendered by
 * recently-viewed.liquid, saves it to localStorage, and renders the
 * carousel of recently viewed products.
 */
(function () {
  const STORAGE_KEY = 'recently_viewed';
  const MAX_PRODUCTS = 4;

  function saveCurrentProduct() {
    const dataEl = document.getElementById('recently-viewed-data');
    if (!dataEl) return; // not on a product page

    let pdpData;
    try {
      pdpData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Recently Viewed: failed to parse product data', e);
      return;
    }

    let arr = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

    // Prevent duplicates
    arr = arr.filter((item) => item.productUrl !== pdpData.productUrl);

    // Add current product
    arr.push(pdpData);

    // Limit to last N
    if (arr.length > MAX_PRODUCTS) {
      arr = arr.slice(arr.length - MAX_PRODUCTS);
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  }

  function renderPriceHtml(item) {
    if (item.hasCompare) {
      return `<div class="c-productPrice-wrap">
                 <p class="c-productPrice">${item.productPrice}</p>
                 <p class="c-productComparePrice">${item.productComparePrice}</p>
               </div>`;
    }
    return `<div class="c-productPrice-wrap">
               <p class="c-productPrice">${item.productPrice}</p>
             </div>`;
  }

  function getRecentPdp() {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (!data.length) return;

    // show heading if we have products
    document.querySelectorAll('.recently-title').forEach((el) => {
      el.style.display = 'block';
    });

    const html = data
      .slice()
      .reverse()
      .map(
        (item) => `
        <div class="c-product">
          <div class="c-product__img">
            <a href="${item.productUrl}">
              <img src="${item.productImg}" alt="${item.productTitle}" loading="lazy"/>
            </a>
          </div>
          <h3 class="c-product__title">
            <a href="${item.productUrl}">${item.productTitle}</a>
          </h3>
          ${renderPriceHtml(item)}
        </div>
      `
      )
      .join('');

    document.querySelectorAll('.js-recentPdpBlock').forEach((el) => {
      el.innerHTML = html;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    saveCurrentProduct();
    getRecentPdp();
  });
})();